"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var FieldPropertyComponents_1 = require("../FieldDetails/FieldPropertyComponents");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
var FieldDetailTextMaxHeight = 80;
var ExpandIconSize = 12;
exports.FieldCard = data_catalog_shared_1.divWithStyle('VizClientFieldCard', {
    paddingTop: widgets_1.TabStyles.Spacing.SmallSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.SmallSpace,
});
exports.FieldCardWrapper = data_catalog_shared_1.divWithStyle('VizClientFieldCardWrapper', {
    display: 'flex',
    flex: 'none',
    flexDirection: 'column',
    width: '100%',
    border: widgets_1.TabStyles.Sizing.BorderWidth + "px solid " + widgets_1.TabStyles.Colors.L6,
    boxSizing: 'border-box',
    borderRadius: 1,
});
exports.FieldCardHeaderWrapper = data_catalog_shared_1.divWithStyle('VizClientFieldCardHeader', {
    backgroundColor: widgets_1.TabStyles.Colors.L2,
    padding: widgets_1.TabStyles.Spacing.MediumSpace
});
exports.FieldCardDetailsWrapper = data_catalog_shared_1.divWithStyle('VizClientFieldCardDetailsWrapper', {
    padding: widgets_1.TabStyles.Spacing.MediumSpace,
});
exports.FieldCardHeaderFieldType = data_catalog_shared_1.divWithStyle('VizClientFieldCardHeaderFieldType', {
    color: widgets_1.TabStyles.Typography.Color.Secondary,
});
exports.FieldCardDetailTitleWrapper = data_catalog_shared_1.divWithStyle('VizClientFieldCardDetailTitleWrapper', {
    marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    borderBottom: widgets_1.TabStyles.Sizing.BorderWidth + "px solid " + widgets_1.TabStyles.Colors.L6,
    display: 'flex',
    alignItems: 'center'
});
exports.FieldCardDetailTitle = data_catalog_shared_1.divWithStyle('VizClientFieldCardDetailTitle', {
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    paddingBottom: widgets_1.TabStyles.Spacing.SmallSpace,
});
exports.FieldCardDetailText = data_catalog_shared_1.divWithStyle('VizClientFieldCardDetailText', {
    maxHeight: FieldDetailTextMaxHeight,
    overflowX: 'hidden',
    overflowY: 'auto',
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace
});
exports.NoDescriptionPlaceholder = data_catalog_shared_1.divWithStyle('VizClientNoDescriptionPlaceholder', [data_catalog_shared_1.elideTextStyle, {
        fontStyle: 'italic',
        color: widgets_1.TabStyles.Typography.Color.Secondary,
        marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    }]);
exports.CalculationDialogHeader = data_catalog_shared_1.divWithStyle('CalculationDialogHeader', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge
});
exports.CalculationDialogTypeInfo = data_catalog_shared_1.divWithStyle('CalculationDialogTypeInfo', {
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    display: 'flex',
    alignItems: 'center'
});
exports.CalculationDialogTextBox = data_catalog_shared_1.divWithStyle('CalculationDialogTextBox', __assign(__assign({}, data_catalog_shared_1.userSelectStyle), { cursor: 'text', maxHeight: 600, padding: widgets_1.TabStyles.Spacing.MediumSpace, border: '1px solid ' + widgets_1.TabStyles.Colors.L6, marginBottom: widgets_1.TabStyles.Spacing.MediumSpace }));
exports.CalulationDialogTextBoxLabel = data_catalog_shared_1.divWithStyle('CalculationDialogTextBoxLabel', {
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace
});
exports.CalculationDialogFooter = data_catalog_shared_1.divWithStyle('CalculationDialogFooter', {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
});
var fadeInAnimation = data_catalog_shared_1.keyframes({
    '0%': { opacity: 0 },
    '10%': { opacity: 1 },
    '90%': { opacity: 1 },
    '100%': { opacity: 0 },
});
exports.calculationDialogCopiedTextAnimationDuration = 3000;
exports.CalculationDialogCopiedText = data_catalog_shared_1.divWithStyle('CalculationDialogCopiedText', {
    color: data_catalog_shared_1.DarkGreenText,
    marginRight: widgets_1.TabStyles.Spacing.MediumSpace,
    animationName: fadeInAnimation,
    animationDuration: exports.calculationDialogCopiedTextAnimationDuration + 'ms',
    animationTimingFunction: 'ease-in-out',
});
exports.expandIconClass = data_catalog_shared_1.cssClass('expandIcon', {
    width: ExpandIconSize,
    height: ExpandIconSize,
});
exports.ExpandIconWrapper = data_catalog_shared_1.divWithStyle('expandIconWrapper', {
    marginLeft: 'auto'
});
exports.FieldsReferencingFieldsWrapper = data_catalog_shared_1.divWithStyle('VizClientFieldsReferencingFieldsWrapper', {
    width: '100%',
    lineHeight: LinksDisplayGrid_1.rowHeight + "px",
    height: LinksDisplayGrid_1.rowHeight + "px",
    verticalAlign: 'top',
    paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    $nest: {
        '> div': {
            height: 'inherit',
            maxHeight: LinksDisplayGrid_1.rowHeight * FieldPropertyComponents_1.fieldsWrapperMaxRows,
            overflow: 'auto',
        }
    }
});
exports.fieldCardDetailTitleIconClass = data_catalog_shared_1.cssClass('VizClientFieldCardDetailTitleIcon', {
    position: 'relative',
    top: widgets_1.TabStyles.Spacing.SmallSpace,
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
});
exports.DescriptionTooltipText = data_catalog_shared_1.divWithStyle('VizClientFieldCardDescriptionTooltipText', {
    // tslint:disable-next-line: deprecation
    fontFamily: widgets_1.TabStyles.Typography.FontFamily,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    color: widgets_1.TabStyles.Typography.Color.Primary,
});
//# sourceMappingURL=VizClientFieldCardStyles.js.map